module.exports = __webpack_public_path__ + "img/sdslabs-logo-dark.b72a3702.svg";